import { useAtomValue } from 'jotai';

import { useGetBadgesQuery } from 'src/hooks/useBadgesQuery';
import useEnableRemoteConfig from 'src/hooks/useEnableRemoteConfig';
import { useGetHistoryProfileUpdatedQuery } from 'src/hooks/useHistoryQuery';
import { historyNotificationAtom, lastVisitedRecentActivityAtom } from 'src/stores/history/atom';

/**
 * History 탭의 레드닷 노출 여부를 반환한다.
 *
 * - Recent Activity: 마지막 방문 이후 profileUpdatedMilliseconds 가 갱신된 카드가 있을 때,
 *   또는 매치 종료로 historyNotificationAtom 이 세팅된 경우
 * - Viewed Me: PROFILE_VIEWED_ME 배지 value === true 일 때
 */
export const useHistoryTabRedDot = (): boolean => {
  const lastVisited = useAtomValue(lastVisitedRecentActivityAtom);
  const historyNotification = useAtomValue(historyNotificationAtom);

  const profileUpdatedQuery = useGetHistoryProfileUpdatedQuery();
  const hasRecentActivityRedDot =
    !!historyNotification ||
    (profileUpdatedQuery.data?.data.some(
      (card) => (card.profileUpdatedMilliseconds ?? 0) > lastVisited
    ) ??
      false);

  const enableViewedMe = useEnableRemoteConfig('enableViewedMe');
  const badgesQuery = useGetBadgesQuery(['PROFILE_VIEWED_ME']);
  const hasViewedMeRedDot =
    enableViewedMe === true &&
    badgesQuery.data?.data.result.badges.find((b) => b.badgeType === 'PROFILE_VIEWED_ME')?.value ===
      true;

  return hasRecentActivityRedDot || hasViewedMeRedDot;
};
